import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import axios from "axios";
import { categorycreateApi, categoryListApi,categoryupdateApi, categorydeleteApi } from "../../../ApiUrl";
export const token = sessionStorage.getItem("accessToken")

const headers = {
    Authorization: `Bearer ${token}`,
};
// create category
export const createcategory = createAsyncThunk('createcategory/category', async (data, { rejectWithValue }) => {
    try {
        const response = await axios.post(categorycreateApi, data, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
export const updatecategory = createAsyncThunk('updatecategory/category', async ({ data, selectedId }, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${categoryupdateApi}/${selectedId}`, data, { headers })
        return response.data.message;
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
})
// get category
export const getcategory = createAsyncThunk('getcategory/category', async () => {
    try {
        const response = await axios.get(`${categoryListApi}?limit=`, { headers });
        return response.data; // Assuming your API response contains a 'categorys' property
    } catch (error) {
        throw new Error(error.message);
    }
});

// delete category
export const deletecategorys = createAsyncThunk('deletecategorys/category', async (categoryid, { rejectWithValue }) => {
    try {
        const response = await axios.delete(`${categorydeleteApi}/${categoryid}`, { headers });
        return response.data._id; // Assuming your API response contains a 'categoryid' property
    } catch (error) {
        return rejectWithValue(error.response.data.message);
    }
});



const categorySlice = createSlice({
    name: 'category',
    initialState: {
        categorys: [],
        status: 'idle',
        error: null,
        message: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            //create category
            .addCase(createcategory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(createcategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(createcategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(action.payload);
                }
            })
            //update category
            .addCase(updatecategory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatecategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.message = action.payload;
                if (state.status === 'succeeded') {
                    toast.success(action.payload);
                }
                state.status = 'idle';

            })
            .addCase(updatecategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
                if (state.status === 'failed') {
                    toast.error(action.payload);
                }
            })
            //getcategorys
            .addCase(getcategory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getcategory.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.categorys = action.payload;
            })
            .addCase(getcategory.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            })

            //delete categorys
            .addCase(deletecategorys.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletecategorys.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.categorys.data = state.categorys.data.filter(categorys => categorys.categoryid !== action.payload);
                state.status = 'idle'
            })
            .addCase(deletecategorys.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    }
});

export default categorySlice.reducer;
